module.exports = __webpack_public_path__ + "img/terroir-choppy-2-mobile.5bdc381c.jpg";